/**
 * Fallback English labels when the API returns Swedish `skill.name` values.
 * Prefer `skills.displayNames.<id>` in en.json when you know stable skill ids.
 * Keys must match `skill.name` after trim + toLowerCase().
 */
export const SKILL_NAME_SV_TO_EN: Record<string, string> = {
    'civil butikskontrollant': 'Civilian Store Controller',
    värd: 'Host',
    ordningsvakt: 'Public order officer',
    väktare: 'Security worker',
};
